import { Form, Input } from 'sections/Form';

import { useLoginForm } from './LoginForm.hooks';

export type UserData = {
  username: string;
  password: string;
};

export function LoginForm(): React.ReactElement {
  const { handleSubmit, register, error, isNewPassword, onSubmit, isLoading } = useLoginForm();

  const inputs: Input[] = [
    {
      name: 'email',
      label: 'email:',
    },
    {
      name: 'password',
      label: 'password:',
      type: 'password',
    },
  ];

  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      buttonLabel="Login"
      error={error}
      messageTitle={
        isNewPassword
          ? 'New password set, you can now login'
          : 'Please enter your account details'
      }
      inputs={inputs}
      register={register}
      hasForgotPassword
      type="login"
      isButtonLoading={isLoading}
    />
  );
}
